var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 130 130",
      "width": "200",
      "height": "200"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0",
      "transform": "matrix(0.4163930118083954, 0, 0, 0.4163930118083954, 0.39041104912757874, 0.4123989939689636)"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(0.4163930118083954, 0, 0, 0.4163930118083954, 0.39041104912757874, 0.4123989939689636)"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier",
      "transform": "matrix(0.4163930118083954, 0, 0, 0.4163930118083954, 0.39041104912757874, 0.4123989939689636)"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('circle', {
    staticStyle: {
      "fill": "rgb(50, 55, 59)"
    },
    attrs: {
      "cx": "148.5",
      "cy": "148.5",
      "r": "148.5"
    }
  })])])])])]), _c('path', {
    staticStyle: {
      "fill": "rgb(38, 44, 48)"
    },
    attrs: {
      "d": "M 229.393 80.816 L 69.775 226.659 C 69.775 226.659 142.655 297 148.5 297 C 228.691 297 299.625 229.104 296.332 144.937 L 229.393 80.816 Z"
    }
  })])]), _c('g', {
    attrs: {
      "id": "group-13",
      "stroke-width": "0",
      "transform": "matrix(0.24660199880599976, 0, 0, 0.24660199880599976, -302.5762634277344, 48.754272460937486)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-14",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(0.24660199880599976, 0, 0, 0.24660199880599976, -302.5762634277344, 48.754272460937486)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-15",
      "transform": "matrix(0.24660199880599976, 0, 0, 0.24660199880599976, -7.414276123046875, -398.85546875)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#e6e9ee"
    },
    attrs: {
      "d": "M111.6,234.8L111.6,234.8L111.6,234.8z"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "x": "357.6",
      "y": "206.4",
      "width": "29.2",
      "height": "25.2"
    }
  }), _c('g', {
    attrs: {
      "id": "group-1",
      "stroke-width": "0",
      "transform": "matrix(1.491933, 0, 0, 1.3672, 325.445709, 159.370392)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(1.491933, 0, 0, 1.3672, 325.445709, 159.370392)"
    }
  }), _c('g', {
    attrs: {
      "id": "svg-1",
      "transform": "matrix(1, 0, 0, 1, -122.579811, 2.918103)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-4",
      "stroke-width": "0",
      "transform": "matrix(1, 0, 0, 1, 123.258591, -2.909988)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(1, 0, 0, 1, 123.258591, -2.909988)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-6",
      "transform": "matrix(1, 0, 0, 1, 123.258591, -2.909988)"
    }
  }, [_c('g'), _c('path', {
    staticStyle: {
      "fill": "rgb(255, 199, 41)"
    },
    attrs: {
      "d": "M111.6,234.8L111.6,234.8L111.6,234.8z"
    }
  }), _c('g'), _c('g', {
    attrs: {
      "id": "svg-2",
      "transform": "matrix(1.542617, 0, 0, 1.542617, -106.233017, -386.189148)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-7",
      "stroke-width": "0",
      "transform": "matrix(0.248047, 0, 0, 0.248047, 167.525253, 343.033752)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(0.248047, 0, 0, 0.248047, 167.525253, 343.033752)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-9",
      "transform": "matrix(0.248047, 0, 0, 0.248047, 167.525253, 343.033752)"
    }
  })])])]), _c('g', {
    attrs: {
      "id": "group-3",
      "transform": "matrix(1.491933, 0, 0, 1.3672, 326.733429, 156.676376)"
    }
  })]), _c('g', {
    attrs: {
      "id": "svg-3",
      "transform": "matrix(0.18084700405597687, 0, 0, 0.18084700405597687, 7.53680419921875, 24.22802734375)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-10",
      "stroke-width": "0",
      "transform": "matrix(1, 0, 0, 1, 107.238968, 30.226717)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-11",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(1, 0, 0, 1, 107.238968, 30.226717)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-12",
      "transform": "matrix(1, 0, 0, 1, 107.238968, 30.226717)"
    }
  }, [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#caa977"
    },
    attrs: {
      "x": "13.438",
      "y": "207.825",
      "width": "214.023",
      "height": "154.009"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#dfcaa3"
    },
    attrs: {
      "y": "170.511",
      "width": "227.461",
      "height": "37.314"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#a88d63"
    },
    attrs: {
      "x": "227.461",
      "y": "207.825",
      "width": "143.992",
      "height": "154.009"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#caa977"
    },
    attrs: {
      "x": "227.461",
      "y": "170.511",
      "width": "157.43",
      "height": "37.314"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#333e48"
    },
    attrs: {
      "d": "M332.096,230.972c6.074,0,11,4.925,11,11s-4.926,11-11,11H285.82c-6.076,0-11-4.925-11-11 s4.924-11,11-11H332.096z"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "rgb(236, 240, 241)"
    },
    attrs: {
      "x": "13.437",
      "y": "284.829",
      "width": "95.963",
      "height": "40.9"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#caa977"
    },
    attrs: {
      "x": "95.475",
      "y": "51.815",
      "width": "164.949",
      "height": "118.695"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#dfcaa3"
    },
    attrs: {
      "x": "85.117",
      "y": "23.057",
      "width": "175.307",
      "height": "28.759"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#a88d63"
    },
    attrs: {
      "x": "260.424",
      "y": "51.815",
      "width": "110.977",
      "height": "118.695"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#caa977"
    },
    attrs: {
      "x": "260.424",
      "y": "23.057",
      "width": "121.332",
      "height": "28.759"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#333e48"
    },
    attrs: {
      "d": "M341.066,69.654c4.682,0,8.478,3.796,8.478,8.478c0,4.683-3.797,8.479-8.478,8.479h-35.664 c-4.684,0-8.479-3.796-8.479-8.479c0-4.682,3.795-8.478,8.479-8.478C305.402,69.654,341.066,69.654,341.066,69.654z"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "rgb(236, 240, 241)"
    },
    attrs: {
      "x": "95.475",
      "y": "111.163",
      "width": "73.959",
      "height": "31.521"
    }
  })])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }